<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <dl class="row">
    <dt class="col-sm-5 text-right">Appointment time</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.displayedAppointmentDate}}
    </dd>

    <dt class="col-sm-5 text-right">Staff member</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.staffMember}}
    </dd>

    <dt class="col-sm-5 text-right">Location</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.location}}
    </dd>
  </dl>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="close('cancel_appointment')">Request
    Cancellation</button>
  <button type="button" class="btn btn-outline-primary" (click)="close('change_appointment')">Request
    Change</button>
</div>
